import Component from '../Component';
import { FoxState } from '../../Prototype/World/Fox';

export default class FoxComponent extends Component {
    public state: FoxState = FoxState.SEARCHING;
}
